<template>
    <md-field :class="{'md-invalid': errors.has(fieldLabel) }">
      <label :for=fieldLabel>{{fieldLabel}}</label>
      <md-input :type="!fieldType ? 'text': fieldType" :name=fieldLabel :id=fieldId v-model=form[fieldName] v-validate="validations" :disabled="sending || disable" @blur="validateOnBlur" />
       <span class="md-error" v-if="errors.has(fieldLabel)">{{ errors.first(fieldLabel) }}</span>
    </md-field>
</template>

<script>
export default {
  name: 'Field',
  data: () => ({
    form: {}
  }),
  props: ['fieldName', 'fieldLabel', 'fieldId', 'fieldValue', 'sending', 'validations', 'fieldType', 'disable'],
  methods: {
    validateField () {
      return this.$validator.validate().then((result) => {
        this.$emit('setfield', {
          'fieldName': [this.fieldName],
          'fieldValue': this.form[this.fieldName]
        })
        return result
      })
    },
    clearField () {
      this.form[this.fieldName] = null
    },
    validateOnBlur () {
      var self = this
      this.$nextTick(() => {
        self.$validator.validate()
      })
      this.$validator.validate()
    }
  },
  created: function () {
    if (this.fieldValue) {
      this.form[this.fieldName] = this.fieldValue
    } else {
      this.form[this.fieldName] = null
    }
  }
}

</script>
